/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Boat(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M221.06055,110.58691,208,106.2334V56a16.01833,16.01833,0,0,0-16-16H136V24a8,8,0,0,0-16,0V40H64A16.01833,16.01833,0,0,0,48,56v50.2334l-13.06055,4.35351A15.98076,15.98076,0,0,0,24,125.76611V160a8.00533,8.00533,0,0,0,.30762,2.19775c15.71972,55.01856,86.11816,73.957,100.07031,77.19483a16.1234,16.1234,0,0,0,7.24414,0c13.95215-3.23779,84.35059-22.17627,100.07031-77.19483A8.00533,8.00533,0,0,0,232,160V125.76611A15.98076,15.98076,0,0,0,221.06055,110.58691ZM136,168a8,8,0,0,1-16,0V112.43262a8,8,0,1,1,16,0Zm56-67.09961L133.05957,81.25391a16.0984,16.0984,0,0,0-10.12012,0L64,100.90039V56H192Z" />
    </Svg>
  );
}

export default Boat;
